import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
export const showRegistrationForm = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationForm.url(options),
    method: 'get',
})

showRegistrationForm.definition = {
    methods: ["get","head"],
    url: '/organizer/v1/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
showRegistrationForm.url = (options?: RouteQueryOptions) => {
    return showRegistrationForm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
showRegistrationForm.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
showRegistrationForm.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showRegistrationForm.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
const showRegistrationFormForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
showRegistrationFormForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationForm
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:31
* @route '/organizer/v1/register'
*/
showRegistrationFormForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationForm.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showRegistrationForm.form = showRegistrationFormForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::register
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:81
* @route '/organizer/v1/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

register.definition = {
    methods: ["post"],
    url: '/organizer/v1/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::register
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:81
* @route '/organizer/v1/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::register
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:81
* @route '/organizer/v1/register'
*/
register.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::register
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:81
* @route '/organizer/v1/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: register.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::register
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:81
* @route '/organizer/v1/register'
*/
registerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: register.url(options),
    method: 'post',
})

register.form = registerForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUser
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:185
* @route '/organizer/v1/check-user'
*/
export const checkUser = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkUser.url(options),
    method: 'post',
})

checkUser.definition = {
    methods: ["post"],
    url: '/organizer/v1/check-user',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUser
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:185
* @route '/organizer/v1/check-user'
*/
checkUser.url = (options?: RouteQueryOptions) => {
    return checkUser.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUser
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:185
* @route '/organizer/v1/check-user'
*/
checkUser.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkUser.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUser
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:185
* @route '/organizer/v1/check-user'
*/
const checkUserForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkUser.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUser
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:185
* @route '/organizer/v1/check-user'
*/
checkUserForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkUser.url(options),
    method: 'post',
})

checkUser.form = checkUserForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
export const showRegistrationFormInertia = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationFormInertia.url(options),
    method: 'get',
})

showRegistrationFormInertia.definition = {
    methods: ["get","head"],
    url: '/organizer/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
showRegistrationFormInertia.url = (options?: RouteQueryOptions) => {
    return showRegistrationFormInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
showRegistrationFormInertia.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: showRegistrationFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
showRegistrationFormInertia.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: showRegistrationFormInertia.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
const showRegistrationFormInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
showRegistrationFormInertiaForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationFormInertia.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::showRegistrationFormInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:212
* @route '/organizer/register'
*/
showRegistrationFormInertiaForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: showRegistrationFormInertia.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

showRegistrationFormInertia.form = showRegistrationFormInertiaForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::registerInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:291
* @route '/organizer/register'
*/
export const registerInertia = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: registerInertia.url(options),
    method: 'post',
})

registerInertia.definition = {
    methods: ["post"],
    url: '/organizer/register',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::registerInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:291
* @route '/organizer/register'
*/
registerInertia.url = (options?: RouteQueryOptions) => {
    return registerInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::registerInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:291
* @route '/organizer/register'
*/
registerInertia.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: registerInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::registerInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:291
* @route '/organizer/register'
*/
const registerInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: registerInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::registerInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:291
* @route '/organizer/register'
*/
registerInertiaForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: registerInertia.url(options),
    method: 'post',
})

registerInertia.form = registerInertiaForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::sendRegistrationOtp
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:225
* @route '/organizer/register/send-otp'
*/
export const sendRegistrationOtp = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendRegistrationOtp.url(options),
    method: 'post',
})

sendRegistrationOtp.definition = {
    methods: ["post"],
    url: '/organizer/register/send-otp',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::sendRegistrationOtp
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:225
* @route '/organizer/register/send-otp'
*/
sendRegistrationOtp.url = (options?: RouteQueryOptions) => {
    return sendRegistrationOtp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::sendRegistrationOtp
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:225
* @route '/organizer/register/send-otp'
*/
sendRegistrationOtp.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendRegistrationOtp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::sendRegistrationOtp
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:225
* @route '/organizer/register/send-otp'
*/
const sendRegistrationOtpForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendRegistrationOtp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::sendRegistrationOtp
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:225
* @route '/organizer/register/send-otp'
*/
sendRegistrationOtpForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendRegistrationOtp.url(options),
    method: 'post',
})

sendRegistrationOtp.form = sendRegistrationOtpForm

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUserInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:0
* @route '/organizer/check-user'
*/
export const checkUserInertia = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkUserInertia.url(options),
    method: 'post',
})

checkUserInertia.definition = {
    methods: ["post"],
    url: '/organizer/check-user',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUserInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:0
* @route '/organizer/check-user'
*/
checkUserInertia.url = (options?: RouteQueryOptions) => {
    return checkUserInertia.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUserInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:0
* @route '/organizer/check-user'
*/
checkUserInertia.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkUserInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUserInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:0
* @route '/organizer/check-user'
*/
const checkUserInertiaForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkUserInertia.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Organizer\Auth\RegisterController::checkUserInertia
* @see app/Http/Controllers/Organizer/Auth/RegisterController.php:0
* @route '/organizer/check-user'
*/
checkUserInertiaForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkUserInertia.url(options),
    method: 'post',
})

checkUserInertia.form = checkUserInertiaForm

const RegisterController = { showRegistrationForm, register, checkUser, showRegistrationFormInertia, registerInertia, sendRegistrationOtp, checkUserInertia }

export default RegisterController